export const group = {
  userDrugGroups: [],
  wardGroups: {hierarchy: [], mapping: {}}
};
